import { render, staticRenderFns } from "./editPremio.vue?vue&type=template&id=9cd71d54&scoped=true"
import script from "./editPremio.vue?vue&type=script&lang=js"
export * from "./editPremio.vue?vue&type=script&lang=js"
import style0 from "./editPremio.vue?vue&type=style&index=0&id=9cd71d54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cd71d54",
  null
  
)

export default component.exports